import s from './index.module.css';
import { useState } from 'react';
import Button from '../../../UI/Button';
import { timetableBeta } from "@/api";
import { useApiSearch } from "@/hooks/useApiSearch";
import SelectPeriod from '@UI/SelectPeriod'
import Select from "@UI/New/Select";
import { compareOptionsByLabel } from "@/helpers/new/compareOptionsByLabel";
import { useEffect } from 'react';

const INPUT_DATE_FORMAT = 'YYYY-MM-DD'
const OUTPUT_DATE_FORMAT = 'DD.MM.YY'

const JournalDownloadExcel = ({
    data
}) => {
    const [up, setUp] = useState();
    const [from, setFrom] = useState();
    const bindPeriod = {
        setFrom: (e) => setUp(e),
        setUp: (e) => setFrom(e),
        initDate: {
            up: up,
            from: from,
        },
    }

    const [selectGroupsAndClasses, setSelectGroupsAndClasses] = useState([])


    const {
        data: groupsAndClasses = [],
        loading: loadingGroupsAndClasses,
        searchQuery: searchQueryGroupsAndClasses,
        setSearchQuery: setSearchQueryGroupsAndClasses
    } = useApiSearch({
        apiMethod: timetableBeta.getGroupsAndClasses,
        responseKey: 'data',
        searchKey: 'search'
    });

    const fieldsGroupsAndClasses = {
        tokenSeparators: [','],
        mode: "multiple",
        loading: loadingGroupsAndClasses,
        showSearch: true,
        allowClear: true,
        filterSort: compareOptionsByLabel,
        filterOption: false,
        onChange: value =>setSelectGroupsAndClasses(value),
        options: groupsAndClasses,
        value: selectGroupsAndClasses,
        placeholder: 'Группа/класс',
        onSearch: setSearchQueryGroupsAndClasses,
        notFoundContent: searchQueryGroupsAndClasses.length < 3 
            ? "Введите 3 или более символов" 
            : "Группы и классы не найдены" 
    };

    useEffect(() => {
        console.log(selectGroupsAndClasses)
    }, [selectGroupsAndClasses])

    return (<>
        <div className={s.title}>
            Выгрузить в EXCEL
        </div>
        <div className={s.body}>
            <div className={s.block}>
                <div className={s.text}>
                    <p>Выберите период</p>
                    <SelectPeriod
                        newDesign={true}
                        className={s.wrapper}
                        classNameSelect={s.select}
                        {...bindPeriod}
                    />
                </div>
                <div className={s.text}>
                    <p>Выберите классы / группы</p>
                    <Select
                        wrapperClassName={s.wrapperSelect}
                        className={s.select2}
                        fields={fieldsGroupsAndClasses}
                    />
                </div>
            </div>
            <Button
                newDesign
                className={s.add}
                action={() => console.log('kk')}
            >Выгрузить</Button>
        </div>
    </>)
}

export default JournalDownloadExcel;